import { Component } from '@angular/core';

@Component({
    selector: 'app-compatibility-card',
    templateUrl: './compatibility-card.component.html',
    styleUrls: ['./compatibility-card.component.scss'],
    standalone: true,
})
export class CompatibilityCardComponent {
  constructor() {}
}
